import { graphClient } from '../../graph-client'
import {
  GET_USERS_TASKS_HOSTS,
  GET_USER_TASK_HOST_FIRST,
} from './gql'

import type { Get, GetList } from './types'

class UserTaskHostService {
  async getFirst(params: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_USER_TASK_HOST_FIRST,
      params,
    )

    return request?.getUserTaskHostFirst
  }

  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_USERS_TASKS_HOSTS,
      { ...params, take, skip: take * skip },
    )

    return request?.getUsersTasksHosts
  }
}
export const userTaskHostService = new UserTaskHostService()
